"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FGridItem = void 0;
const react_1 = __importDefault(require("react"));
const FGridItem = ({ size = [12, 12, 12], dir = "row", alignX = "", alignY = "", style, width, height, className = "", children = undefined, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: `f-grid-item ${size && size.length === 1
                ? `f-grid-item-lg-${size[0]}`
                : size.length === 2
                    ? `f-grid-item-lg-${size[0]} f-grid-item-md-${size[1]}`
                    : size.length === 3
                        ? `f-grid-item-lg-${size[0]} f-grid-item-md-${size[1]} f-grid-item-sm-${size[2]}`
                        : ""} ${className} dir-${dir} jc jc-${alignX} ai ai-${alignY} ${width ? "w-100" : ""}`, style: style }, children)));
};
exports.FGridItem = FGridItem;
//# sourceMappingURL=FgridItem.js.map